import React from "react";
import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";
import FinalCTA from "@/components/FinalCTA";
import BrochureCTA from "@/components/BrochureCTA";
import { PROCESS } from "@/data/content";

export default function Process() {
  return (
    <div data-testid="page-process" className="bg-[#FAF6F1]">
      
      <SEO title="Our 7-Phase Event Planning Process" description="From discovery call to post-event closure — a clear, calm, seven-phase process with named owners, written deliverables and a dedicated devotional-event track." path="/process" />
<section className="pt-28 md:pt-32 pb-10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <p className="pill">Our Process</p>
          <h1 className="font-display text-5xl md:text-7xl lg:text-[84px] leading-[1.0] mt-6 text-[#3B312D] max-w-4xl">
            Seven phases from first <span className="italic text-[#B65980]">conversation</span> to final toast.
          </h1>
          <p className="mt-7 max-w-2xl text-[16.5px] text-[#3B312D]/80 leading-relaxed">
            A clear, calm path. Each phase has named owners, written deliverables, and the right level
            of detail — never more, never less than your event needs.
          </p>
        </div>
      </section>

      <section className="pb-16 md:pb-24">
        <div className="max-w-[1100px] mx-auto px-6 md:px-10">
          <div className="relative">
            <div className="absolute left-4 md:left-1/2 top-2 bottom-2 w-px bg-gradient-to-b from-transparent via-[#B65980]/40 to-transparent" />
            <div className="space-y-12 md:space-y-20">
              {PROCESS.map((p, i) => {
                const left = i % 2 === 0;
                return (
                  <Reveal key={p.step} delay={i * 80} className={`relative grid grid-cols-1 md:grid-cols-2 items-center gap-6 ${left ? "" : "md:[&>div:first-child]:order-2"}`}>
                    <div className="md:px-10">
                      <p className="font-display text-7xl md:text-8xl text-[#C5A059]/75 leading-none">{p.step}</p>
                      <h3 className="font-display text-3xl md:text-4xl mt-3 text-[#3B312D]">{p.title}</h3>
                      <p className="mt-4 text-[15.5px] text-[#3B312D]/80 leading-relaxed max-w-md">{p.desc}</p>
                    </div>
                    <div className="md:px-10">
                      <div className="lux-card p-6 md:p-7">
                        <p className="text-[11px] tracking-[0.24em] uppercase text-[#8A9A7B] font-semibold">Phase</p>
                        <p className="mt-2 font-editorial italic text-xl text-[#3B312D]">{p.title}</p>
                        <div className="hairline my-5"/>
                        <ul className="space-y-2 text-[13.5px] text-[#3B312D]">
                          <li>· Senior point of contact</li>
                          <li>· Written deliverable</li>
                          <li>· Aligned timeline</li>
                          <li>· No surprises</li>
                        </ul>
                      </div>
                    </div>
                    <span className="hidden md:flex absolute left-1/2 -translate-x-1/2 w-3 h-3 rounded-full bg-[#B65980] ring-4 ring-[#FAF6F1]" />
                  </Reveal>
                );
              })}
            </div>
          </div>

          {/* Devotional note */}
          <div className="mt-20 rounded-[22px] bg-[#F4DCD8]/40 p-8 md:p-10 border border-[#B65980]/20">
            <p className="pill-rose">For Devotional Events</p>
            <h3 className="font-display text-2xl md:text-3xl mt-4 text-[#3B312D] leading-snug">
              A process tuned for reverence and tradition.
            </h3>
            <p className="mt-4 text-[15.5px] text-[#3B312D]/85 leading-relaxed max-w-3xl">
              For jagrans, chowkis, bhajan sandhyas, kirtans, and prayer ceremonies we additionally align ritual
              flow, artist coordination, prasad, seating, sound, and cultural requirements with complete sensitivity —
              so the spiritual core of the evening stays untouched.
            </p>
          </div>
        </div>
      </section>

      <BrochureCTA />
      <FinalCTA />
    </div>
  );
}
